import { render } from "./OnboardingWiland.vue?vue&type=template&id=73c27651"
import script from "./OnboardingWiland.vue?vue&type=script&lang=js"
export * from "./OnboardingWiland.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/onboarding/OnboardingWiland.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73c27651"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73c27651', __exports__)) {
    api.reload('73c27651', __exports__)
  }
  
  module.hot.accept("./OnboardingWiland.vue?vue&type=template&id=73c27651", () => {
    api.rerender('73c27651', render)
  })

}


export default __exports__